export const apiUrl: string = import.meta.env.VITE_API_URL;
export const supabaseUrl: string = import.meta.env.VITE_SUPABASE_ENDPOINT;
export const supabaseKey: string = import.meta.env.VITE_SUPABASE_KEY;
